<template>
	<div class="Left">
		<div :class="item.path == active ? 'Left-Point Left-Point-active' : 'Left-Point'" v-for="(item, index) in leftPoint"
			:key="index" @click="activePoint(item, index)">
			<img v-if="item.path == active" :src="item.active" alt="" />
			<img v-else :src="item.noActive" alt="" />
			<span>{{ item.name }}</span>
		</div>
	</div>
</template>
<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
import Api from "@/components/Api/index.js"
export default {
	name: "Left",
	components: {},
	// 定义属性
	data() {
		return {
			active: 'organization',
			leftPoint: [],
		};
	},
	// 计算属性，会监听依赖属性值随之变化
	computed: {},
	// 方法集合
	methods: {
		activePoint(item, index) {
			const map = {
				'机构钱包': 5,
				'我的交易': 4,
				'客户及分销': 6
			}
			if (map[item.name]) {
				this.$store.commit("setCheckIndex", map[item.name])
			}
			this.active = item.path;
			this.$router.push({
				path: item.path,
			});
		},
		getUserInfo() {
			let arr = [{
				noActive: require("@/assets/png/book.png"),
				active: require("@/assets/png/book2.png"),
				name: "机构看板",
				path: 'organization',
				isAuthority: true
			},
			{
				noActive: require("@/assets/png/team.png"),
				active: require("@/assets/png/team2.png"),
				name: "机构团队",
				path: 'institutionalTeam',
				isAuthority: true
			},
			{
				noActive: require("@/assets/png/wallet.png"),
				active: require("@/assets/png/wallet2.png"),
				name: "机构钱包",
				path: 'institutionalWallet',
				isAuthority: true
			},
			{
				noActive: require("@/assets/png/personal.png"),
				active: require("@/assets/png/personal2.png"),
				name: "我的看板",
				path: 'myBoard',
				isAuthority: true
			},
			{
				noActive: require("@/assets/png/pen.png"),
				active: require("@/assets/png/pen2.png"),
				name: "我的交易",
				path: 'myDeal',
			},
			{
				noActive: require("@/assets/png/folder.png"),
				active: require("@/assets/png/folder2.png"),
				name: "客户及分销",
				path: "clientAnddistribution",
			},
			// {
			// 	noActive: require("@/assets/png/marketing.png"),
			// 	active: require("@/assets/png/marketing2.png"),
			// 	name: "营销中心",
			// 	path: "暂未开发",
			// },
			{
				noActive: require("@/assets/png/tongji.png"),
				active: require("@/assets/png/tongji2.png"),
				name: "统计",
				path: "statistics",
			},
			]
			new Api("user").selectUserInfo().then((result) => {
				if (result.status == 200) {
					if (result.data.isFirstAccount == 1) {
						this.leftPoint = arr
					} else {
						this.leftPoint = arr.filter(item => !item.isAuthority)
					}
					this.active = this.$route.name
				}
			}).catch((err) => {
				this.$message({
					type: "error",
					message: '系统异常',
				});
			});
		}
	},

	watch: {
		$route(n, m) {
			this.active = n.name;
		}
	},
	// 生命周期 - 创建完成（可以访问当前this实例）
	created() { },
	// 生命周期 - 挂载完成（可以访问DOM元素）
	mounted() {
		this.getUserInfo()

	},
	beforeCreate() { }, // 生命周期 - 创建之前
	beforeMount() { }, // 生命周期 - 挂载之前
	beforeUpdate() { }, // 生命周期 - 更新之前
	updated() { }, // 生命周期 - 更新之后
	beforeDestroy() { }, // 生命周期 - 销毁之前
	destroyed() { }, // 生命周期 - 销毁完成
	activated() { }, // 如果页面有keep-alive缓存功能，这个函数会触发
};
</script>

<style scoped lang="scss">
.Left {
	display: inline-flex;
	flex-direction: column;
}

.Left-Point-active {
	background: #ff6637;
	color: white;
}

.Left-Point {
	width: 1rem;
	height: 0.8rem;
	display: inline-flex;
	flex-direction: column;
	justify-content: center;

	>img {
		height: 0.24rem;
		width: 0.24rem;
		position: relative;
		left: 50%;
		transform: translateX(-50%);
	}

	>span {
		font-size: 12px;
		margin-top: 5px;
		display: flex;
		justify-content: center;
	}
}
</style>
